export default function ReportFlagIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_72383_232583'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_72383_232583)'>
        <path
          d='M7 12.7692V20.75C7 20.9625 6.92808 21.1406 6.78425 21.2843C6.64042 21.4281 6.46225 21.5 6.24975 21.5C6.03708 21.5 5.859 21.4281 5.7155 21.2843C5.57183 21.1406 5.5 20.9625 5.5 20.75V4.404C5.5 4.14783 5.58667 3.93317 5.76 3.76C5.93317 3.58667 6.14783 3.5 6.404 3.5H19.1115C19.2757 3.5 19.4235 3.538 19.555 3.614C19.6867 3.68983 19.7912 3.7885 19.8685 3.91C19.9458 4.0315 19.9938 4.16667 20.0125 4.3155C20.031 4.46417 20.0061 4.61583 19.9378 4.7705L18.452 8.13475L19.9378 11.4988C20.0061 11.6534 20.031 11.8051 20.0125 11.9537C19.9938 12.1026 19.9458 12.2378 19.8685 12.3593C19.7912 12.4808 19.6867 12.5794 19.555 12.6552C19.4235 12.7312 19.2757 12.7692 19.1115 12.7692H7ZM7 11.2692H18.2327L17.15 8.8655C17.0437 8.638 16.9905 8.39425 16.9905 8.13425C16.9905 7.87425 17.0437 7.63075 17.15 7.40375L18.2327 5H7V11.2692Z'
          fill='#DA0808'
        />
      </g>
    </svg>
  );
}
